import { render, staticRenderFns } from "./LabelContractsReservesEditPanelDialog.vue?vue&type=template&id=70633d62"
import script from "./LabelContractsReservesEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./LabelContractsReservesEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports